import policy from './websiteAnalytics.js';
export const { websiteEventContext, NECESSARY_WEBSITE_EVENTS, CHANNELS } = policy;
